import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import PaymentMethodFormState from 'js/stores/forms/PaymentMethodFormState';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';
import CreditCardForm from 'js/components/common/CreditCardForm';

import Container from './Container';
import Title from './Title';

@inject('page')
@observer
export default class Form extends Component {
  paymentMethodForm = PaymentMethodFormState.create({
    creditCard: this.props.page.credit_card ? getSnapshot(this.props.page.credit_card) : {},
  });

  onSubmit = () => {
    if(!this.paymentMethodForm.creditCard.isFilledIn){
      return false;
    }
    this.props.page.creditCardSaved(this.paymentMethodForm.creditCard);
  };

  render() {
    const creditCard = this.paymentMethodForm.creditCard;
    // creditCard.setBillingAddress(this.props.page.address);
    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit}>
          <Title>Payment method</Title>
          <CreditCardForm labels={false} creditCard={creditCard} />
          <SubmitRow>
            <Button type="submit" autoFocus={creditCard.isFilledIn} disabled={!creditCard.isFilledIn}>
              Save
            </Button>
          </SubmitRow>
        </AvForm>
      </Container>
    );
  }
}
